module.exports = __webpack_public_path__ + "static/media/ServiceLandingImages.8e43a81d.svg";